import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const figures = Array.from(this.element.querySelectorAll(":scope > .bulletin-figure"));
    if (figures.length < 2) return;

    this.figures = figures;
    this.index = 0;

    this.buildTrack();
    this.buildChrome();
    this.sync();

    this.boundScroll = this.onScroll.bind(this);
    this.boundKey = this.onKey.bind(this);
    this.track.addEventListener("scroll", this.boundScroll, { passive: true });
    this.element.addEventListener("keydown", this.boundKey);
  }

  disconnect() {
    if (this.track) this.track.removeEventListener("scroll", this.boundScroll);
    this.element.removeEventListener("keydown", this.boundKey);
  }

  buildTrack() {
    this.track = document.createElement("div");
    this.track.className = "bulletin-carousel-track";
    this.figures.forEach((fig) => {
      fig.classList.add("bulletin-carousel-slide");
      this.track.appendChild(fig);
    });
    this.element.appendChild(this.track);
    this.element.tabIndex = 0;
  }

  buildChrome() {
    const chevron = (direction) =>
      `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="16" height="16">
        <path d="${direction === "left" ? "M15 6l-6 6 6 6" : "M9 6l6 6-6 6"}"
          fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;

    this.prevButton = document.createElement("button");
    this.prevButton.type = "button";
    this.prevButton.className = "bulletin-carousel-arrow bulletin-carousel-arrow-prev";
    this.prevButton.setAttribute("aria-label", "Previous image");
    this.prevButton.innerHTML = chevron("left");
    this.prevButton.addEventListener("click", () => this.goTo(this.index - 1));

    this.nextButton = document.createElement("button");
    this.nextButton.type = "button";
    this.nextButton.className = "bulletin-carousel-arrow bulletin-carousel-arrow-next";
    this.nextButton.setAttribute("aria-label", "Next image");
    this.nextButton.innerHTML = chevron("right");
    this.nextButton.addEventListener("click", () => this.goTo(this.index + 1));

    this.counter = document.createElement("div");
    this.counter.className = "bulletin-carousel-counter";

    this.element.appendChild(this.prevButton);
    this.element.appendChild(this.nextButton);
    this.element.appendChild(this.counter);
  }

  goTo(next) {
    const clamped = Math.max(0, Math.min(this.figures.length - 1, next));
    const slide = this.figures[clamped];
    if (!slide) return;
    this.track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
  }

  onScroll() {
    if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    this.scrollFrame = requestAnimationFrame(() => this.sync());
  }

  onKey(event) {
    if (event.key === "ArrowLeft") { event.preventDefault(); this.goTo(this.index - 1); }
    if (event.key === "ArrowRight") { event.preventDefault(); this.goTo(this.index + 1); }
  }

  sync() {
    const trackLeft = this.track.scrollLeft;
    let closest = 0;
    let bestDelta = Infinity;
    this.figures.forEach((fig, i) => {
      const delta = Math.abs(fig.offsetLeft - trackLeft);
      if (delta < bestDelta) { bestDelta = delta; closest = i; }
    });
    this.index = closest;
    this.counter.textContent = `${this.index + 1} / ${this.figures.length}`;
    this.prevButton.disabled = this.index === 0;
    this.nextButton.disabled = this.index === this.figures.length - 1;
  }
}
